import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../App/slice/selectors';
import TooltipParagraph from '../Catalog/tooltipParagraph';
import useTitleSize from 'app/components/StyledTable/useTitleSize';
import StyledTable from 'app/components/StyledTable';
import { PassengerType } from '../PassengerInfo/types';
import moment from 'moment';
import _ from 'lodash';
interface IPassengerInformationProps {
  dataPassenger: any;
}
const PassengerInformation: React.FC<IPassengerInformationProps> = props => {
  const { dataPassenger } = props;
  const tableRef = useRef<any>();
  const translations = useSelector(selectTranslations);
  const passengerType = {
    [`${PassengerType.ADULT}`]: translations?.['b2b.txt.adult'],
    [`${PassengerType.CHILD}`]: translations?.['b2b.txt.child'],
    [`${PassengerType.INFANT}`]: translations?.['b2b.txt.infant'],
  };
  const titleColumnSizes = useTitleSize({
    title: [
      'b2b.txt.agent-table-order',
      'b2b.txt.passengerName',
      'b2b.txt.passengerType',
      'b2b.form.birth',
      'b2b.txt.documentType',
      'b2b.txt.guardian',
    ],
  });
  const getGuardian = (id: string | number) => {
    const passenger = dataPassenger?.[Number(id)];
    if (_.isEmpty(passenger)) {
      return '-';
    }
    const name = `${passenger.title} ${passenger.lastName}/${passenger.firstName}`;
    return name;
  };
  const columnTicket = [
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.agent-table-order']}
        </div>
      ),
      key: 'order',
      render: (value, _, index) => {
        const itemOrder = index + 1;
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.agent-table-order'],
            }}
          >
            {`#${itemOrder}`}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.passengerName']}
        </div>
      ),
      dataIndex: 'passengerName',
      key: 'passengerName',
      render: (text, record, index) => {
        const name = `${record.title} ${record.lastName}/${record.firstName}`;
        return (
          <TooltipParagraph
            style={{
              textAlign: 'left',
              marginBottom: 0,
            }}
            ellipsis={{ rows: 2 }}
          >
            {name}
          </TooltipParagraph>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.passengerType']}
        </div>
      ),
      dataIndex: 'passengerType',
      key: 'passengerType',
      render: (text, record, index) => {
        return (
          <div
            style={{
              textAlign: 'left',
              minWidth: titleColumnSizes['b2b.txt.passengerType'],
            }}
          >
            {passengerType[record?.passengerType] || '-'}
          </div>
        );
      },
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.form.birth']}
        </div>
      ),
      dataIndex: 'dateOfBirth',
      key: 'dateOfBirth',
      render: value => (
        <div
          style={{
            textAlign: 'left',
            minWidth: titleColumnSizes['b2b.form.birth'],
          }}
        >
          {value ? moment(value).format('DD/MM/YYYY') : '-'}
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.documentType']}
        </div>
      ),
      dataIndex: 'documentType',
      key: 'documentType',
      render: (text, record, index) => (
        <div
          style={{
            textAlign: 'left',
            minWidth: titleColumnSizes['b2b.txt.documentType'],
          }}
        >
          {record.documentType && record.documentType !== 'NONE' ? (
            <>
              {record.documentType} <br />
              {record.documentType === 'CCCD'
                ? record.documentNumber
                : record.documentType === 'PASSPORT'
                ? record.passportNumber
                : ''}
            </>
          ) : (
            '-'
          )}
        </div>
      ),
    },
    {
      title: (
        <div style={{ textAlign: 'left' }}>
          {translations?.['b2b.txt.guardian']}
        </div>
      ),
      dataIndex: 'guardian',
      key: 'guardian',
      render: value => (
        <TooltipParagraph
          style={{
            minWidth: titleColumnSizes['b2b.txt.guardian'],
            maxWidth: titleColumnSizes['b2b.txt.guardian'],
            textAlign: 'left',
            marginBottom: 0,
          }}
          ellipsis={{ rows: 1 }}
        >
          {getGuardian(value)}
        </TooltipParagraph>
      ),
    },
  ];
  return (
    <StyledTable
      tableRef={tableRef}
      dataSource={dataPassenger}
      columns={columnTicket}
      pagination={false}
      emptyText={translations?.['b2b.txt.haveNoData']}
      tableProps={{
        scroll: {
          x: dataPassenger?.length ? 'auto' : 'max-content',
          y: dataPassenger?.length ? '50vh' : undefined,
        },
      }}
      styleSlots={{
        antTableContainer: {
          overflow: 'hidden',
        },
        antTableHeader: {
          border: 'none !important',
          borderRadius: '0 !important',
        },
        tableCSS: {
          borderTopLeftRadius: !dataPassenger?.length ? '' : '0 !important',
          borderTopRightRadius: !dataPassenger?.length ? '' : '0 !important',
        },
        antTableBody: {
          paddingBottom: 10,
        },
      }}
    />
  );
};
export default PassengerInformation;
